// src/components/Sections/ClubStatementSection/ClubStatementSection.jsx

import React from 'react';
import './ClubStatementSection.scss';

export default function ClubStatementSection() {
  return (
    <section id="club" className="club-statement section-v2">
      <div className="container club-statement__inner">
        <p className="eyebrow">The club for public golf</p>

        <h2>
          You don&apos;t need a home course
          <span>to have a home in golf.</span>
        </h2>

        <p className="club-statement__copy">
          You should not need a private-club address to feel part of golf.
          The Tour brings your rounds, friends, friendly competition, and
          season history together—while you keep playing public courses
          on your own schedule.
        </p>

        <div className="club-statement__rail" aria-label="Membership pillars">
          <span>Play</span>
          <i aria-hidden="true"></i>
          <span>Compete</span>
          <i aria-hidden="true"></i>
          <span>Belong</span>
        </div>
      </div>
    </section>
  );
}
